import Header from "@/components/Header";
import FeastBanner from "@/components/FeastBanner";
import Hero from "@/components/Hero";
import FrancisPrayer from "@/components/FrancisPrayer";
import About from "@/components/About";
import Mission from "@/components/Mission";
import Schedule from "@/components/Schedule";
import ParishCalendar from "@/components/ParishCalendar";
import Ministries from "@/components/Ministries";
import Sacraments from "@/components/Sacraments";
import MassIntentions from "@/components/MassIntentions";
import Appointments from "@/components/Appointments";
import TombBlessing from "@/components/TombBlessing";
import FamilySurveyBanner from "@/components/FamilySurveyBanner";
import ParishApps from "@/components/ParishApps";
import OpenMeetingsRibbon from "@/components/OpenMeetingsRibbon";
import { isTombSeason } from "@/data/tombBlessing";
import Personnel from "@/components/Personnel";
import Construction from "@/components/Construction";
import Announcements from "@/components/Announcements";
import Gallery from "@/components/Gallery";
import FiestaGallery from "@/components/FiestaGallery";
import Contact from "@/components/Contact";
import PilgrimLibrary from "@/components/PilgrimLibrary";
import GKKDirectory from "@/components/GKKDirectory";
import ShareSection from "@/components/ShareSection";
import Footer from "@/components/Footer";
import ScrollTop from "@/components/ScrollTop";
import FrancisConnectWidget from "@/components/FrancisConnectWidget";

export default function Home() {
  return (
    <div className="bg-parchment-100">
      <Header />
      <FeastBanner />
      <main>
        {isTombSeason() && <TombBlessing />}
        <Hero />
        <OpenMeetingsRibbon />
        <FamilySurveyBanner />
        <ParishApps />
        <FrancisPrayer />
        <About />
        <Mission />
        <Schedule />
        <ParishCalendar />
        <Ministries />
        <GKKDirectory />
        <Sacraments />
        <MassIntentions />
        <Appointments />
        <Personnel />
        <Construction />
        <Announcements />
        <Gallery />
        <FiestaGallery preview />
        <Contact />
        <PilgrimLibrary />
        <ShareSection />
      </main>
      <Footer />
      <ScrollTop />
      <FrancisConnectWidget />
    </div>
  );
}
